/* 
 */

import {useState}                           from 'react'

const RotaCopyOverlay = ({api, selectInfo, done, setError}) => {
    
    const {start, end, 
                extendedProps: 
                    { apiEvent: { PartyID: ePartyID,
                                  RotaTypeID: rotaTypeID = 0} = {} } = {},
                resource: { id: rPartyID} = {} }    = selectInfo
    
    /* comes from internal event or api depending whether we are creating a new 
     * rota entry */
    const partyID = rPartyID? rPartyID: ePartyID
    
    const [days, setDays]                 = useState(1)
    
    const handleClick = e => {
        
        e.preventDefault()
        
        createRotas(api, rotaTypeID, partyID, start, end, days)
        done()
    }
    
    const handleChange = e => {
        e.preventDefault()
        
        setDays( e.target.value )
        
    }
    
    return <div>
    
        <p>Copy this entry for the next</p>
        <select name='days' value={days} onChange={handleChange} >
            <option value='1' >1</option>
            <option value='2' >2</option>
            <option value='3' >3</option>
            <option value='4' >4</option>
        </select>
        <p>days</p>
    
        <button onClick={handleClick} >Copy</button><span> </span><span> </span>
            <a href='.' onClick={e=>{e.preventDefault();done()}} >Cancel</a>
    </div>
}

const createRotas = ( api, rotaTypeID, partyID, start, end, numCopies ) => {
    
    const addDays = (date, days) => { // copy and advance days
        const result = new Date( date )
        result.setDate( date.getDate() + days )
        return result
    } 
    
    for ( let i = 1; i <= numCopies; i++ ){ // how oldfashioned
        
        const newStart = addDays( start,    i )
        const newEnd   = addDays( end,      i )
        
        api.createRota(partyID, newStart.toISOString(), 
                                newEnd.toISOString(), 
                                rotaTypeID)
            .then( r => r.apiResult )
            .then( apiResult => { console.log('done') } )
            .catch( err => console.log( err ) )
    }
    
}

export default RotaCopyOverlay


